export default __webpack_public_path__ + "static/contactt-a36a2153f35f5c17ca895f3c345244ea.jpg";